export const pretextNbsp = (value: string) => {
  if (value.includes(' и ')) {
    return value.replace(' и ', ' и ');
  }

  if (value.includes(' в ')) {
    return value.replace(' в ', ' в ');
  }

  if (value.includes(' по ')) {
    return value.replace(' по ', ' по ');
  }

  if (value.includes(' на ')) {
    return value.replace(' на ', ' на ');
  }

  if (value.includes(' с ')) {
    return value.replace(' с ', ' с ');
  }

  if (value.includes(' к ')) {
    return value.replace(' к ', ' к ');
  }

  if (value.includes(' за ')) {
    return value.replaceAll(' за ', ' за ');
  }

  return value;
};

export const i18nPluralize = (choice: number, choicesLength: number) => {
  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return choicesLength < 4 ? 2 : 3;
};
